<template>
  <header>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">

          <router-link v-if="implementationCompany == 'amica'" class="logo" :to="'/'"><img src="@/assets/images/logo-claim.svg" alt="amica"></router-link>
          <router-link v-if="implementationCompany == 'hansa'" class="logo" :to="'/'"><img src="@/assets/images/logo-hansa.png" alt="hansa"></router-link>

          <!-- <a @click.prevent="handleMobileMenu()" class="mobile-handler" href="">
            <span></span>
            <span></span>
            <span></span>
          </a> -->

          <ul v-if="menuVisbility">
            <!-- <li><router-link v-html="$t('header.product_registration')" :to="'/product-registration'"></router-link></li>
            <li><router-link v-html="$t('header.promotion_rules')" :to="'/'"></router-link></li>
            <li><router-link v-html="$t('header.eligible_products')" :to="'/eligible-products'"></router-link></li>
            <li><a v-html="$t('header.terms_and_conditions')" href="/7yearwarranty/files/terms.pdf"></a></li>
            <li><a v-html="$t('header.warranty_conditions')" href="/7yearwarranty/files/warranty.pdf"></a></li>
            <li><router-link :to="'/contact'">{{ $t('header.contact') }}</router-link></li> -->
          </ul>

        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { globalStore } from '@/main'

  export default {
    name: 'Header',
    data () {
      return {
        menuVisbility: true
      }
    },
    computed: {
      implementationCompany () {
        return globalStore.IMPLEMENTATION_COMPANY
      }
    },
    methods: {
      handleMobileMenu () {
        this.menuVisbility = !this.menuVisbility
      }
    },
    mounted () {
      let cmp = this

      if (window.innerWidth > 991) {
        cmp.menuVisbility = true
      } else {
        cmp.menuVisbility = false
      }

      window.addEventListener("resize", function () {
        if (window.innerWidth > 991) {
          cmp.menuVisbility = true
        } else {
          cmp.menuVisbility = false
        }
      });
    }
  }
</script>

<style lang="scss" scoped>
  header {
    // text-align: center;
    background: #fff;
    padding: 10px 0;
    position: relative;

    -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.2);

    @media only screen and (max-width : 991px) {
      text-align: left;
    }

    a.logo {
      margin-right: 60px;
      display: inline-block;

      @media only screen and (max-width : 1199px) {
        margin-right: 20px;
      }

      @media only screen and (max-width : 991px) {
        width: 100%;
        margin-right: 0px;
      }

      img {
        width: 100px;
      }
    }

    a.mobile-handler {
      position: absolute;
      right: 20px;
      top: 10px;
      border: 1px #ddd solid;
      width: 40px;
      height: 40px;
      padding-top: 8px;
      border-radius: 4px;
      display: none;

      @media only screen and (max-width : 991px) {
        display: inline-block;
      }

      &:hover {
        background: #eee;
      }

      span {
        width: 60%;
        height: 2px;
        background: #aaa;
        display: block;
        margin: 0 auto 8px;;
      }

    }

    ul {
      padding-left: 0px;
      margin-bottom: 0px;
      list-style: none;
      display: inline-block;

      @media only screen and (max-width : 991px) {
        width: 100%;
        margin-top: 30px;
      }

      li {
        display: inline-block;
        text-transform: uppercase;

        @media only screen and (max-width : 991px) {
          width: 100%;
          text-align: center;
        }

        a {
          display: inline-block;
          padding: 10px 20px;
          color: #000;
          font-size: 16px;
          font-weight: 700;

          @media only screen and (max-width : 1199px) {
            font-size: 14px;
            padding: 10px 10px;
          }

          &:hover {
            color: #e41429;
            text-decoration: none;
          }
        }

      }
    }
  }
</style>
